import { useState } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { DemoModal } from "./components/DemoModal";

// Import all section components
import {
  Nav,
  HeroSection,
  OpportunitySection,
  ProductSection,
  HowItWorksSection,
  BeforeAfterSection,
  CaseStudySection,
  CredibilitySection,
  TestimonialsSection,
  CTASection,
  Footer,
} from "./components/sections";

// Main Landing Page
const LandingPage = () => {
  const [demoModalOpen, setDemoModalOpen] = useState(false);

  return (
    <div className="min-h-screen bg-[#0a0a0a]" data-testid="landing-page">
      <Nav onRequestDemo={() => setDemoModalOpen(true)} />
      <main>
        <HeroSection onRequestDemo={() => setDemoModalOpen(true)} />
        <OpportunitySection />
        <ProductSection />
        <HowItWorksSection />
        <CredibilitySection />
        <BeforeAfterSection />
        <CaseStudySection />
        <TestimonialsSection />
        <CTASection onRequestDemo={() => setDemoModalOpen(true)} />
      </main>
      <Footer />
      <DemoModal open={demoModalOpen} onOpenChange={setDemoModalOpen} />
    </div>
  );
};

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<LandingPage />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
